<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size:15px; font-weight: bold">manage bond tracking</small>
      </legend>
      <div></div>
      <div class="bondtrackingsLoader">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <i class="fa fa-spinner fa-spin" style="font-sixe:24px; color: blue"></i>loading bondtrackings...
      </div>
      <vue-good-table
        :columns="columns"
        :rows="systemBondtrackings"
        :fixed-header="true"
        :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
          }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'Action'">
            <button
              v-b-tooltip.hover.bottom="'Edit bond tracking!'"
              class="btn btn-primary btn-sm btn-rounded"
              @click="viewBondtracking(props.row.id)"
            >
              <i class="fa fa-edit"></i> Edit bond trackings
            </button>
          </span>
        </template>
      </vue-good-table>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "File code",
          field: "file_code",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter file reference"
          }
        },
        {
          label: "Customer name",
          field: "customer_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter customer"
          }
        },
        {
          label: "Bill of landing",
          field: "bill_landing",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter bill of landing"
          }
        },
        {
          label: "Cargo no",
          field: "container_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "cargo number"
          }
        },
        {
          label: "Cargo size",
          field: "cargo_size",
          type: "text"
        },
        {
          label: "Truck no",
          field: "truck_no",
          type: "text"
        },
        {
          label: "Tailer no",
          field: "trailer_no",
          type: "text"
        },
        {
          label: "T812 entry",
          field: "t812_entry",
          type: "text"
        },

        {
          label: "Bond amount",
          field: "bond_amount",
          type: "text"
        },
        {
          label: "Ro",
          field: "Ro",
          type: "text"
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true
        }
      ]
    };
  },
  created() {
    this.loadBondtrackings();
  },
  computed: {
    ...mapGetters(["systemBondtrackings"])
  },
  methods: {
    ...mapActions(["loadBondtrackings", "viewBondtracking"])
  }
};
</script>


// WEBPACK FOOTER //
// src/bondtrackings/managebondtrackings.vue